import { IRotationNode } from '../types/ViewModel/IRotationNode';
import { BerthCall } from '../types/ViewModel/BerthCall';
import { CargoOperation } from '../types/ViewModel/CargoOperation';
import { PortCall } from '../types/ViewModel/PortCall';
import { Rotation } from '../types/ViewModel/Rotation';
import { LatestVoyageData } from '../types/ViewModel/LatestVoyageData';

export const getParentBerthCallFromNode = (rotationNode: IRotationNode): BerthCall | null => {
    const cargo: CargoOperation = rotationNode as CargoOperation;
    return cargo.berthCall;
};

export const getParentPortCallFromNode = (rotationNode: IRotationNode | null): PortCall | null => {
    const bc: BerthCall = rotationNode as BerthCall;
    return bc.portCall;
};

export const getAllUniqueVoyageNumbers = (rotation: Rotation, latestVoyageData: LatestVoyageData, includeLatest = false): string[] => {
    const voyList: string[] = [];
    rotation.portCallArray.forEach((pc) => {
        if (pc.voyageNumber1 && !voyList.find((o) => o === pc.voyageNumber1)) voyList.push(pc.voyageNumber1);
        if (pc.voyageNumber2 && !voyList.find((o) => o === pc.voyageNumber2)) voyList.push(pc.voyageNumber2);
    });
    if (includeLatest) {
        return voyList.sort().reverse();
    }
    return voyList
        .filter((o) => !latestVoyageData || +o !== latestVoyageData.voyageNumber1)
        .sort()
        .reverse();
};

// Inserts a port call into the rotation at the end of other port calls with the same voyage number
// If the portcall belongs to a voyage before (lower number) than all other port calls in currently loaded rotation, it will be inserted before them
export const insertPortCallBasedOnVoyageNumber = (rotation: Rotation, portCall: PortCall, selectedVoyages: string[]): void => {
    const voyageNumber = portCall.voyageNumber1 || portCall.voyageNumber2;

    if (!selectedVoyages?.includes(voyageNumber)) {
        return; // Do not insert if the voyage number is not in the selected voyages
    }

    const indexOfFirstPortCallWithHigherVoyageNumber = rotation.portCallArray.findIndex(
        (pc) => pc.voyageNumber1 && +pc.voyageNumber1 >= +voyageNumber
    );

    if (indexOfFirstPortCallWithHigherVoyageNumber !== -1) {
        // Insert before the first port call with a higher voyage number
        rotation.portCallArray.splice(indexOfFirstPortCallWithHigherVoyageNumber, 0, portCall);
    } else {
        rotation.portCallArray.push(portCall);
    }
};
